import ApiInstance from "./ApiInstance";

export type AppointmentType = "intro" | "coaching" | "therapy";

export interface BookResult {
  appointmentId: string;
  status: "pending_payment" | "confirmed";
  checkoutUrl?: string;
  videoRoom?: { provider: string; roomUrl?: string; roomName?: string };
  // Usage-based employer model: the member's yearly employer bundle (and the
  // org's overage pool) is used up — this booking is self-paid. Neutral,
  // member-only signal; the employer is never notified.
  employerFundingExhausted?: boolean;
}

export interface Appointment {
  _id: string;
  psychologistId: string;
  type: AppointmentType;
  start: string;
  end: string;
  priceCents: number;
  status: string;
  fundCode?: string;
  hasRoom?: boolean;
  reimbursementSnapshot?: { perSessionCents: number; youPayCents: number };
}

export interface CancelResult {
  ok: boolean;
  status: string;
  // Refund outcome of the withdrawal/cancellation flow (WER VI.47/VI.50).
  refund?: { status: "refunded" | "none" | "failed"; amountCents?: number; reason?: string };
  message?: string;
}

class AppointmentApi {
  // withdrawalConsent: WER VI.46 §8 — express request to perform the session
  // within the 14-day withdrawal period (required for paid sessions within 14 days).
  async book(body: { psychologistId: string; type: AppointmentType; start: string; fundCode?: string; withdrawalConsent?: boolean }): Promise<BookResult> {
    const { data } = await ApiInstance.getApi().post("/appointments", body);
    return data;
  }
  async get(id: string): Promise<Appointment> {
    const { data } = await ApiInstance.getApi().get(`/appointments/${id}`);
    return data;
  }
  async room(id: string): Promise<{ roomUrl: string; provider: string }> {
    const { data } = await ApiInstance.getApi().get(`/appointments/${id}/room`);
    return data;
  }
  async list(): Promise<Appointment[]> {
    const { data } = await ApiInstance.getApi().get("/appointments");
    return data.appointments;
  }
  async cancel(id: string): Promise<CancelResult> {
    const { data } = await ApiInstance.getApi().post(`/appointments/${id}/cancel`, {});
    return data;
  }
}

const appointmentApi = new AppointmentApi();
export default appointmentApi;
